export const once = (f: (...arg: any[]) => void) => {
  const result = (...arg: any[]) => {
    if (result.executed) {
      return
    }
    result.executed = true
    f(...arg)
  }
  result.executed = false
  return result
}
